<template>
	<b-row>
		<b-col cols="12" xl="12">
			<div id="month-select">
				<MonthSelect :DateDefaultSelect="DateDefaultSelect" @setDateDefaultSelect="setDateDefaultSelect" />
			</div>
		</b-col>
		<b-col cols="12" xl="12">
			<b-table-simple
				small
				caption-top
				responsive
				:sticky-header="`${getHeaderHeight}px`"
				:style="{ 'min-height': minHeight + 'px' }"
				sticky-column="first"
				ref="my-table"
				v-click-outside="onOutsideClick"
			>
				<b-thead>
					<b-tr>
						<b-th class="text-center middle row-header-fixed" @mouseover="handleStopDragging">
							<header-row-tables :isFixedStart="true" />
						</b-th>
						<b-th
							:class="{ 'text-center middle row-header-locations': true, 'bg-header-today': isToday(item.key) }"
							v-for="item of mapFields"
							:key="generateSecureId(`${item.key}`)"
							v-b-popover.hover.bottom.html="isToday(item.key) && returnHeaderRow()"
						>
							<header-row-tables :item="item" :isFixedStart="false" />
						</b-th>
					</b-tr>
				</b-thead>
				<b-tbody ref="tableRef" @mousedown="startScrollingLeft" @mouseup="stopScrollingLeft">
					<b-tr v-show="mapTimesheets.length === 0">
						<b-td :colspan="tsfields.length === 0 ? 1 : tsfields.length" class="text-center border-left init-background default-data-empty">
							<div>
								<div class="text-muted fs-14 w-100">{{ this.FormMSG(2, 'No data available') }}</div>
							</div>
						</b-td>
					</b-tr>
					<b-tr v-show="mapTimesheets.length !== 0" v-for="(item, index) of mapTimesheets" :key="index">
						<b-td class="sticky-column-body" style="border: 0.005rem solid rgba(226, 230, 235, 0.85)" @mouseover="handleStopDragging">
							<div class="d-flex flex-row justify-content-start align-items-center">
								<div class="d-flex flex-column justify-content-start p-1" style="width: 150px; height: 60px">
									<div class="font-weight-bold fs-14">{{ item.fullName }}</div>
									<div>{{ item.departmentName }}</div>
								</div>
								<div class="d-flex flex-column justify-content-start align-items-center pd-1">
									<div class="d-flex flex-row w-100 show-hover"></div>
									<div class="d-flex flex-row w-100 show-hover">
										<b-button
											:disabled="checkNotSubmitted(item)"
											@click="sendAllForValidation(item)"
											size="sm"
											class="btn bg-transparent border-0"
											v-b-tooltip.hover.bottom.html="`${FormMSG(13, 'Send all for validation')}`"
										>
											<component :is="getLucideIcon(ICONS.SEND.name)" :color="ICONS.SEND.color" :size="16" :stroke-width="2.25" />
										</b-button>
									</div>
								</div>
							</div>
						</b-td>
						<b-td
							v-for="data of mapFields"
							:key="generateSecureId(`${data.key}`)"
							style="border: 0.005rem solid rgba(226, 230, 235, 0.85)"
							@contextmenu.stop.prevent="onActiveContextMenu($event, data, item)"
							@click.stop.prevent="(e) => handleAllActionPlanning(e, item, data.key)"
							@mousedown="(e) => startDrag(e, item, data.key)"
							@mouseover="(e) => selectCell(e, item, data.key)"
							@mouseup="(e) => endDrag(e)"
							:id="generateSecureId(`${item.id + item.fullName + item.departmentName + item.functionName + data.key}`)"
							:class="{
								'init-background hover-not-empty': getWorked(data.key, item.tsDays),
								'edit-background hover-is-empty': !getWorked(data.key, item.tsDays),
								'bg-row-today': isToday(data.key)
							}"
						>
							<cell-info
								:keyCell="data.key"
								:arrayTsDays="item.tsDays"
								:getWorked="getWorked(data.key, item.tsDays)"
								:labelStatus="getLabelStatus(getStatus(data.key, item.tsDays))"
								:labelStatusColor="getStatusColor(getStatus(data.key, item.tsDays))"
								:tooltipContentOvertime="tooltipContentOvertime(data.key, item.tsDays)"
								:getSalary="getSalary(data.key, item.tsDays)"
							/>
						</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
			<div v-if="isBusy" class="d-flex justify-content-center align-items-center" style="height: 20px; gap: 5px">
				<div class="loading">{{ this.FormMSG(9, 'Loading') }}</div>
				<div class="bars-5"></div>
			</div>
			<div v-else class="d-flex flex-row justify-content-center align-items-center" style="height: 20px">
				<div class="end-of-list">{{ this.FormMSG(10, 'End of list') }}</div>
			</div>
			<template>
				<context-menu ref="ContextMenu" />
			</template>
		</b-col>
		<MoreDetailPlanningCell
			:itemGenerated="detailGenerateItem"
			:showDetailModalCell="showDetailModalCell"
			@hideModal="hideModal"
			:isMultiple="isMultiple"
		/>
		<b-modal
			header-class="header-class-modal-doc-package"
			:title="FormMSG(17, 'Refuse this day')"
			class="modal-danger"
			v-model="successModalRejectedTsDay"
			no-close-on-backdrop
			ok-variant="danger"
			ok-only
		>
			<b-form-group :label="FormMSG(18, 'Enter your comment:')" label-for="comment" :label-cols="4">
				<b-form-textarea id="comment" v-model="rejectComment" :placeholder="this.FormMSG(19, 'Enter your remarks...')" rows="3"></b-form-textarea>
			</b-form-group>
			<template #modal-footer>
				<div class="w-100">
					<b-button @click="finaliseTsDayReject" variant="danger" size="sm" class="float-right"> OK </b-button>
				</div>
			</template>
		</b-modal>
	</b-row>
</template>
<script>
import MoreDetailPlanningCell from './MoreDetailPlanningCell.vue';
import HeaderRowTables from './HeaderRowTables.vue';
import CellInfo from './CellInfo.vue';
import ContextMenu from './ContextMenu.vue';
import MonthSelect from '@/components/EntryForCrew/Timesheets/TimesheetsEfcTables/MonthSelect';
import ShowDetailPlanningCell from '@/components/EntryForCrew/Timesheets/TimesheetsEfcTables/ShowDetailPlanningCell';
import languageMessages from '@/mixins/languageMessages';
import globalMixin from '@/mixins/global.mixin';
import isSingleProjectMixin from '@/mixins/isSingleProject.mixin';
import { getTimesheetsToValidate, getTimesheetsDetailAuthToValidate, rejectTsDay, undoRejectTsDay } from '@/cruds/timesheets-efc.crud';
import { FILTER_STRING_TIME_SHEET, NAME_CARDS_TIMESHEET_EFC, ACTION_EFC_TIMESHEET } from '@/utils/utils';
import { rendCurrency } from '~helpers';
import { generateSecureId } from '@/shared/utils';
import { classStatus } from '@/shared/global-status';
import { VALIDATION_TYPE, OPTION_CONTEXT_MENU } from '@/shared/constants';
import moment from 'moment';

export default {
	name: 'PlanningViewTables',
	components: { MonthSelect, ShowDetailPlanningCell, HeaderRowTables, CellInfo, ContextMenu, MoreDetailPlanningCell },
	mixins: [languageMessages, isSingleProjectMixin, globalMixin],
	props: {
		isActiveBusy: {
			type: Boolean,
			required: false,
			default: false
		},
		totalsPlanningTsDays: {
			type: Number,
			required: false,
			default: 0
		},
		useComponent: {
			type: Boolean,
			required: false
		},
		id: {
			type: String,
			required: false
		},
		setFilter: {
			type: Function,
			required: false
		},
		setPages: {
			type: Function,
			required: false
		},
		groupByFilter: {
			type: String,
			required: false
		},
		onSearch: {
			type: Function,
			required: false
		},
		selectDate: {
			type: Array,
			required: false
		},
		formChanged: {
			type: Function,
			required: false
		},
		hover: {
			type: Boolean,
			required: false
		},
		timesheets: {
			type: Array,
			required: false
		},
		tsfields: {
			type: Array,
			required: false
		},
		currentpage: {
			type: Number,
			required: false
		},
		perpage: {
			type: Number,
			required: false
		},
		hv: {
			type: String,
			required: false
		},
		DateDefaultSelect: {
			type: Object,
			required: false,
			immediate: true
		},
		open: {
			type: Boolean,
			required: false
		},
		isPersistDataPlanning: {
			type: Boolean,
			required: false
		},
		isActionCrud: {
			type: String,
			required: false
		}
	},
	data: () => {
		const { groupByDate, groupByPerson, groupByStatus, planningView } = FILTER_STRING_TIME_SHEET;
		const { timecards_One, timesheets_Two } = NAME_CARDS_TIMESHEET_EFC;
		const { addData, updateData, deleteData } = ACTION_EFC_TIMESHEET;
		return {
			filter: '',
			currentForm: {
				value: 0,
				text: 'Select Month'
			},
			groupActionCell: '',
			groupByActionValue: null,
			groupByPerson,
			groupByDate,
			planningView,
			groupByStatus,
			addData,
			updateData,
			deleteData,
			selected: '',
			setPage: 0,
			timecards_One,
			timesheets_Two,
			reset: true,
			notReset: false,
			rendCurrency,
			isNoCtrolSelect: false,
			isKeyDate: '',
			dataForPlanning: [],
			generateSecureId,
			isBusy: false,
			showMenu: false,
			showMenuMultiple: false,
			menuX: 0,
			menuY: 0,
			selectedItem: null,
			MyFunctionHideContextMenu: false,
			scrollPosition: 0,
			isActiveClickCell: 1,
			sendDataToModalPlanning: [],
			isDragging: false,
			scrollLeftStart: 0,
			startX: 0,
			selectedCells: [],
			stateGlobalData: [],
			indexActif: 0,
			dateSelectedCells: [],
			stateGlobalDates: [],
			startIndex: 0,
			endIndex: 0,
			vuexStoreForPlanning: [],
			windowWidth: window.innerWidth,
			minHeight: 300,
			isFixedAppBar: false,
			isResizeScreen: false,
			isFixedAppBarValue: null,
			datePersist: [],
			arraysId: [],
			activeStart: false,
			dragging: false,
			classStatus,
			dataToValidate: [],
			dataToValidate: [],
			isValid: false,
			isReject: false,
			showDetailModalCell: false,
			successModalRejectedTsDay: false,
			rejectComment: '',
			showDetailData: [],
			rejectData: [],
			isSelectMultiple: false,
			mapSelectedCells: [],
			TYPE_SELECT_PLANNING: {
				CLICK: 'ONLY_CLICK',
				SHIFT: 'SHIFT_CLICK',
				CTRL: 'CTRL_CLICK'
			},
			TYPE_CONTEXT_MENU: {
				ONE_SELECT: 'one-select',
				MULTI_SELECT: 'multi-select'
			},
			detailGenerateItem: [],
			isMultiple: false
		};
	},
	watch: {
		isActiveBusy: {
			handler(newVal) {
				this.isBusy = newVal;
				return newVal;
			},
			immediate: true,
			deep: true
		},
		isFixedAppBar: {
			handler(newVal) {
				if (newVal) {
					const sideBar = this.$refs['my-table'].$parent.$parent.$parent.$parent.$parent.$refs['side-bar'];
					if (sideBar) {
						sideBar.$el.addEventListener('click', (e) =>
							setTimeout(() => {
								this.handleResize(e);
							}, 250)
						);
					}
				}
				return newVal;
			},
			immediate: true,
			deep: true
		},
		tsfields: {
			async handler(newVal) {
				if (newVal.length !== 0) {
					this.$nextTick(() => {
						const myTable = this.$refs['my-table'];
						if (myTable) {
							const tableScrollBody = myTable.$el;
							tableScrollBody.addEventListener('mousemove', this.detectDirection);
							tableScrollBody.addEventListener('mouseup', this.stopDrag);
							tableScrollBody.addEventListener('scroll', this.onScroll);
						}
					});
				}
				return newVal;
			},
			immediate: true,
			deep: true
		},
		timesheets: {
			async handler(newVal, oldVal) {
				const data = [...this.dataForPlanning];
				await Promise.all(data).then((res) => {
					if (res) {
						this.activeCellsPlanningColor(res);
						return true;
					}
				});
				if (this.isBusy) {
					return newVal;
				} else {
					return oldVal;
				}
			},
			immediate: true,
			deep: true
		},
		open: {
			handler(newVal) {
				if (newVal !== false) {
					if (this.isActionCrud === this.addData) {
						this.sendDataToModalPlanning = [...this.dataForPlanning];
						this.$emit('sendDataModalPlanning', this.sendDataToModalPlanning);
					}
				} else {
					if (this.isPersistDataPlanning) {
						this.sendDataToModalPlanning = [...this.dataForPlanning];
						this.$emit('sendDataModalPlanning', this.sendDataToModalPlanning);
					} else {
						this.initActionsInPlanning();
						this.dataForPlanning = [];
						this.sendDataToModalPlanning = [];
						this.$emit('sendDataModalPlanning', this.sendDataToModalPlanning);
						this.$emit('showModalPlanningContextUpdate', this.sendDataToModalPlanning);
					}
				}
				return newVal;
			},
			immediate: true,
			deep: true
		},
		dataForPlanning: {
			handler(newVal) {
				let data = newVal;
				if (data.length > 1) {
					this.isSelectMultiple = true;
				} else {
					this.isSelectMultiple = false;
				}
				this.$emit('setDataSizeModalPlanning', data);
				return newVal;
			},
			immediate: true,
			deep: true
		},
		showMenu: {
			handler(newVal) {
				if (newVal === false) {
					this.menuX = 0;
					this.menuY = 0;
				}
				return newVal;
			},
			immediate: true,
			deep: true
		},
		mapTimesheets: {
			handler(newVal) {
				return newVal;
			},
			immediate: true,
			deep: true
		}
	},
	created() {
		this.GetTimesheetsToValidate();
	},
	mounted() {
		let main = document.getElementById('default-container-body');
		window.addEventListener('resize', this.handleResize);
		if (main) {
			main.addEventListener('scroll', this.handleScroll);
		}
		let buttons = Array.from(document.body.querySelectorAll('button'))[1];
		buttons.addEventListener('click', this.resizeScreen);
	},
	beforeDestroy() {
		if (this.$refs['my-table'] !== undefined) {
			const tableScrollBody = this.$refs['my-table'].$el;
			let main = document.getElementById('default-container-body');
			if (tableScrollBody) {
				tableScrollBody.removeEventListener('scroll', this.onScroll);
			}
			if (main) {
				main.removeEventListener('scroll', this.handleScroll);
			}
		}
	},
	computed: {
		mapFields() {
			return this.tsfields.slice(1);
		},
		getHeaderHeight() {
			let WindowInnerHeight = window.innerHeight;
			let screenHeightPlanning = Math.round((WindowInnerHeight * 86.58) / 100);
			return screenHeightPlanning;
		},
		setDataTableFields() {
			return this.dataTable;
		},
		mapTimesheets() {
			if (this.$refs['my-table'] !== undefined) {
				const tableScrollBody = this.$refs['my-table'].$el;
				tableScrollBody.addEventListener('scroll', this.onScroll);
			}
			return this.timesheets.sort((a, b) => +b.id - +a.id); // verified this express monaday
		}
	},
	methods: {
		async onOutsideClick() {
			this.showMenu = false;
			this.showMenuMultiple = false;
			this.$refs['ContextMenu'].$refs['menu'].hide();
			this.$refs['ContextMenu'].optionContextMenu = null;
			this.selectedItem = null;
			let data = [...this.dataForPlanning];
			await Promise.all(data).then((res) => {
				if (res) {
					this.activeCellsPlanningColor(res);
					return true;
				}
			});
		},
		returnHeaderRow() {
			return `<div class="row-today-popover">${this.FormMSG(378, "This is today's date column")}</div>`;
		},
		isToday(date) {
			const dateNow = new Date();
			const year = dateNow.getFullYear();
			const month = dateNow.getMonth() + 1;
			const day = dateNow.getDate();
			const toDay = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year.toString().padStart(2, '0')}`;
			return date === toDay;
		},
		handleScroll(event) {
			const scrollTop = event.target.scrollTop;
			const headerContext = document.getElementById('header-context');
			let headerSelectDate = document.getElementById('month-select');
			let sizeComponentHeaderOption = 0;
			let sizeComponentHeaderDate = 0;
			if (headerSelectDate) {
				let { height: heightOfComponentSelectDate } = headerSelectDate.getBoundingClientRect();
				sizeComponentHeaderOption = heightOfComponentSelectDate;
			}
			if (headerContext) {
				const { height: heightComponentHeaderOption } = headerContext.getBoundingClientRect();
				sizeComponentHeaderDate = heightComponentHeaderOption;
			}
			const globalHeightHeaderComponent = sizeComponentHeaderDate + sizeComponentHeaderOption;
			const newVal = scrollTop - (globalHeightHeaderComponent + 148);
			this.isFixedAppBarValue = newVal;
			if (newVal > 0) {
				this.isFixedAppBar = true;
				this.activeFixedAppBar();
			} else {
				this.isFixedAppBar = false;
				this.clearFixedAppBar();
			}
		},
		clearFixedAppBar() {
			const headRefLocation = Array.from(document.querySelectorAll('th'));
			const itemTh = headRefLocation;
			for (let i = 0; i < itemTh.length; i++) {
				itemTh[i].classList.remove('fixed-app-bar');
				itemTh[i].style.top = `0px`;
			}
		},
		activeFixedAppBar() {
			const headRefLocation = Array.from(document.querySelectorAll('th'));
			const itemTh = headRefLocation;
			for (let i = 0; i < itemTh.length; i++) {
				itemTh[i].classList.add('fixed-app-bar');
				itemTh[i].style.setProperty('top', `${Math.abs(this.isFixedAppBarValue - 2) || 55}px`, 'important');
			}
		},
		resizeScreen(event) {
			event.preventDefault();
			this.isResizeScreen = !this.isResizeScreen;
			this.clearFixedAppBar();
			if (this.isResizeScreen) {
				if (this.isFixedAppBar) {
					this.activeFixedAppBar();
					return true;
				} else {
					this.clearFixedAppBar();
					return true;
				}
			} else {
				if (this.isFixedAppBar) {
					this.activeFixedAppBar();
					return true;
				} else {
					this.clearFixedAppBar();
					return true;
				}
			}
		},
		handleResize(e) {
			let tableScrollBody = this.$refs['my-table'];
			if (tableScrollBody !== undefined) {
				let widthTable = 0;
				if (tableScrollBody && tableScrollBody.$el) {
					widthTable = tableScrollBody.$el.clientWidth;
				}
				this.windowWidth = widthTable;
				this.resizeScreen(e);
			}
		},
		async onOutsideClick() {
			this.showMenu = false;
			this.showMenuMultiple = false;
			this.$refs['ContextMenu'].$refs['menu'].hide();
			this.$refs['ContextMenu'].optionContextMenu = null;
			this.selectedItem = null;
			const { data } = this.generateCellSelected(this.selectedItem);
			await Promise.all(data).then((res) => {
				if (res) {
					this.activeCellsPlanningColor(res);
					return true;
				}
			});
		},
		returnHeaderRow() {
			return `<div class="row-today-popover">${this.FormMSG(378, "This is today's date column")}</div>`;
		},
		isToday(date) {
			const dateNow = new Date();
			const year = dateNow.getFullYear();
			const month = dateNow.getMonth() + 1;
			const day = dateNow.getDate();
			const toDay = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year.toString().padStart(2, '0')}`;
			return date === toDay;
		},
		async GetTimesheetsToValidate() {
			const tsToValidate = await getTimesheetsToValidate();
			if (tsToValidate && tsToValidate.length > 0) {
				let arraysIdToValidate = [];
				for (const item of tsToValidate) {
					let result = await getTimesheetsDetailAuthToValidate(+item.id);
					if (result) {
						arraysIdToValidate.push(...result);
					}
				}
				this.dataToValidate = arraysIdToValidate;
			}
		},
		async finaliseTsDayReject() {
			try {
				if (this.rejectData.length !== 0) {
					const comments = this.rejectComment;
					const response = await Promise.all(
						this.rejectData.map(async ({ id }) => {
							const newID = +id;
							return await rejectTsDay(newID, comments);
						})
					);
					if (response !== null) {
						return true;
					} else {
						return false;
					}
				}
			} finally {
				this.successModalRejectedTsDay = false;
				this.$emit('handleRefreshReject');
				this.GetTimesheetsToValidate();
				this.rejectComment = '';
				this.rejectData = [];
			}
		},
		getStatus(key, arrays) {
			let _data = arrays;
			if (_data !== undefined) {
				let result = _data.filter((item) => {
					if (moment(item.date).format('DD/MM/YYYY') === key) {
						return true;
					}
					return false;
				});
				if (result.length !== 0) {
					return result[0].validated;
				}
			}
		},
		getStatusColor(validated) {
			let retval = 'not-submitted';
			if (validated == 1) {
				retval = 'info';
			} else if (validated == 2) {
				retval = 'pending';
			} else if (validated == 8) {
				retval = 'validated';
			} else if (validated == 4 || validated == 16) {
				retval = 'refused';
			}
			return retval;
		},
		getLabelStatus(value) {
			return this.GetTextFromMenuNumberAndMenuValue(1008, value);
		},
		getUniqueCombination(data) {
			let uniqueCombinations = new Set();
			let uniqueData = data.filter((item) => {
				let combination = `${item.date}-${item.userId}`;
				if (!uniqueCombinations.has(combination)) {
					uniqueCombinations.add(combination);
					return true;
				}
				return false;
			});
			return uniqueData;
		},
		getWorked(key, arrays) {
			let _data = arrays;
			if (_data !== undefined) {
				let result = _data.filter((item) => {
					if (moment(item.date).format('DD/MM/YYYY') === key) {
						return true;
					}
					return false;
				});
				if (result.length !== 0) {
					let hours = result[0].hours.toString().padStart('2', '0');
					let minutes = result[0].minutes.toString().padStart('2', '0');
					return `${hours}:${minutes}`;
				}
			}
		},
		getDataOnCell(key, arrays) {
			let _data = arrays.tsDays;
			let item = undefined;
			if (_data !== undefined) {
				let result = _data.filter((item) => {
					const isValidCell = moment(item.date).format('DD/MM/YYYY') === key;
					if (isValidCell) {
						return true;
					}
					return false;
				});
				if (result.length > 0) {
					item = result[0];
				}
				return { ...arrays, tsDay: item };
			}
		},
		getSalary(key, arrays) {
			let _data = arrays;
			if (_data !== undefined) {
				let result = _data.filter((item) => {
					if (moment(item.date).format('DD/MM/YYYY') === key) {
						return true;
					}
					return false;
				});
				if (result.length !== 0) {
					return `${rendCurrency(result[0].salary)}`;
				}
			}
		},
		tooltipContentOvertime(key, arrays) {
			let hours = this.getWorked(key, arrays);
			let salary = this.getSalary(key, arrays);
			return `${this.FormMSG(3, 'Total worked: ')} ${hours}<br />${this.FormMSG(4, 'Salary: ')} ${salary}`;
		},
		activeCellsPlanningColor(data) {
			if (data !== undefined) {
				for (let i = 0; i < data.length; i++) {
					const checkSecuredIdElement = document.getElementById(data[i].securedId);
					if (checkSecuredIdElement) {
						const style = checkSecuredIdElement.style;
						document.getElementById(data[i].securedId).style;
						document.getElementById(data[i].securedId).style = style;
						document.getElementById(data[i].securedId).style.backgroundColor = '#00a09c';
						document.getElementById(data[i].securedId).style.color = '#fff';
						document.getElementById(data[i].securedId).style.border = '0.005rem solid rgba(226, 230, 235, 0.85)';
						document.getElementById(data[i].securedId).style.height = '50px';
					}
				}
			}
		},
		inactiveCellsPlanningColor(data) {
			if (data !== undefined) {
				for (let i = 0; i < data.length; i++) {
					const checkSecuredIdElement = document.getElementById(data[i].securedId);
					if (checkSecuredIdElement) {
						const style = checkSecuredIdElement.style;
						document.getElementById(data[i].securedId).style = style;
						document.getElementById(data[i].securedId).style.border = '0.005rem solid rgba(226, 230, 235, 0.85)';
						document.getElementById(data[i].securedId).style.height = '50px';
					}
				}
			}
		},
		startDrag(event, item, key) {
			if (event.button === 0) {
				this.dragging = true;
			}
		},
		selectCell(event, item, key) {
			if (event.button === 0) {
				if (this.dragging) {
					this.handleShiftWithClick(event, item, key);
				}
			}
		},
		handleStopDragging() {
			this.dragging = false;
		},
		endDrag(event) {
			if (event.button === 0) {
				this.dragging = false;
			}
		},
		onRunDefaultAfterSelected() {
			this.mapSelectedCells = this.mapSelectedCells.map((item) => ({ ...item, isNoActiveChift: true }));
			return this.mapSelectedCells;
		},
		arrayDiffPlanning(rowItem, TYPE) {
			let arrayActive = [],
				arrayDisabled = [];
			const indexOfItem = this.mapSelectedCells.findIndex((item) => item.securedId === rowItem.securedId);
			if (TYPE === this.TYPE_SELECT_PLANNING.CLICK) {
				this.vuexStoreForPlanning = [];
				this.onRunDefaultAfterSelected();
				if (indexOfItem === -1) {
					const filterItem = this.mapSelectedCells.filter((item) => item.securedId !== rowItem.securedId);
					this.mapSelectedCells = [rowItem];
					arrayActive = this.mapSelectedCells;
					arrayDisabled = filterItem;
				} else {
					const typeActionPlanning = this.mapSelectedCells.splice(indexOfItem, 1)[0];
					if (!typeActionPlanning.isNoActiveChift) {
						const item = { ...typeActionPlanning, isNoActiveChift: true };
						arrayActive = [item];
						arrayDisabled = this.mapSelectedCells.filter((item) => item.securedId !== typeActionPlanning.securedId);
						this.mapSelectedCells = arrayActive;
					} else {
						if (this.mapSelectedCells.length !== 0) {
							const filterItem = this.mapSelectedCells.filter((item) => item.securedId !== rowItem.securedId);
							arrayDisabled = filterItem;
							arrayActive = [rowItem];
							this.mapSelectedCells = arrayActive;
						} else {
							arrayDisabled = [...this.mapSelectedCells, typeActionPlanning];
							arrayActive = this.mapSelectedCells;
							this.mapSelectedCells = arrayActive;
						}
					}
				}
				return { arrayActive, arrayDisabled };
			}
			if (TYPE === this.TYPE_SELECT_PLANNING.CTRL) {
				this.vuexStoreForPlanning = [];
				this.onRunDefaultAfterSelected();
				if (indexOfItem === -1) {
					arrayActive = [...this.mapSelectedCells, rowItem];
					this.mapSelectedCells = arrayActive;
				} else {
					arrayDisabled = this.mapSelectedCells.splice(indexOfItem, 1);
					arrayActive = this.mapSelectedCells;
					this.mapSelectedCells = arrayActive;
				}
				return { arrayActive, arrayDisabled };
			}
			if (TYPE === this.TYPE_SELECT_PLANNING.SHIFT) {
				if (this.mapSelectedCells.length === 0) {
					arrayActive = [rowItem];
					this.mapSelectedCells = arrayActive;
				} else {
					const mapLastSelectPlanning = this.mapSelectedCells.filter((item) => item.isNoActiveChift === true);
					const size = mapLastSelectPlanning.length - 1;
					const startItem = mapLastSelectPlanning[size];
					const endItem = rowItem;
					const mapBeforeActiveShiftItems = mapLastSelectPlanning.slice(0, size) || [];
					const dataPlanning = [startItem, endItem];
					const { arrayActiveShift, cellPreviousInactive } = this.getShiftPlanningActive(dataPlanning);
					const _mapSelectedCells = this.getUniqueCombination([...this.mapSelectedCells, ...arrayActiveShift]);
					const getDifference = (array1, array2) => {
						const ArrayToActive = array1.filter((obj1) => !array2.some((obj2) => obj1.securedId === obj2.securedId));
						const ArrayInActive = array2.filter((obj2) => array1.some((obj1) => obj2.securedId === obj1.securedId));
						return { ArrayToActive, ArrayInActive };
					};
					const { ArrayToActive, ArrayInActive } = getDifference(_mapSelectedCells, cellPreviousInactive);
					arrayActive = [...mapBeforeActiveShiftItems, ...ArrayToActive];
					this.mapSelectedCells = arrayActive;
					arrayDisabled = ArrayInActive;
				}

				return { arrayActive, arrayDisabled };
			}
		},
		getShiftPlanningActive(data) {
			let shiftData = [];
			const uniques = data.filter((item) => !_.isNil(item)).map((item) => ({ ...item, date: item.date }));
			const rest = uniques[0].date.split('/').slice(1).join('/');
			const dateHeader = uniques
				.map((item) => {
					const startDate = item.date.toString().split('/')[0];
					return { ...item, startDate };
				})
				.map((item) => +item.startDate);
			let min_date = Math.min(...dateHeader);
			let max_date = Math.max(...dateHeader, 0);
			const ArrayOfIndex = data.filter((item) => !_.isNil(item)).map((item) => item.indexOfItem);
			const startOfIndex = Math.min(...ArrayOfIndex);
			const endOfIndex = Math.max(...ArrayOfIndex, 0);
			const start = startOfIndex;
			const end = endOfIndex + 1;
			const rows = [...this.mapTimesheets].slice(start, end);
			for (let i = 0; i < rows.length; i++) {
				let item = rows[i];
				let j = 0;
				let startDate = min_date;
				const headerCulumn = this.mapFields;
				while (startDate <= max_date) {
					const key = startDate.toString().padStart(2, '0') + '/' + rest;
					const isExistInHeaderColumn = headerCulumn.findIndex((item) => item.key === key);
					if (isExistInHeaderColumn !== -1) {
						const generateID = generateSecureId(`${item.id + item.fullName + item.departmentName + item.functionName + key}`);
						const tsDay = this.getTsDayOneCell(item, key);
						const securedId = generateID;
						const isNoActiveChift = false;
						const cell = { securedId, item, key, tsDay, isNoActiveChift };
						const rowItem = this.generateCellsItem(cell);
						shiftData = [...shiftData, rowItem];
					}
					startDate++;
					j++;
				}
			}
			const size = this.vuexStoreForPlanning.length - 1;
			const cellPrevious = this.vuexStoreForPlanning[size] || [];
			this.vuexStoreForPlanning = [...this.vuexStoreForPlanning, shiftData];
			let arrayToClear = [];
			for (let z = 0; z < cellPrevious.length; z++) {
				const _item = shiftData.find((item) => item.securedId === cellPrevious[z].securedId);
				if (_.isNil(_item)) {
					arrayToClear.push(cellPrevious[z]);
				}
			}
			return { arrayActiveShift: shiftData, cellPreviousInactive: arrayToClear };
		},
		getTsDayOneCell(item, key) {
			if (item !== undefined || item !== null) {
				if (!_.isNil(item.tsDays)) {
					let tsDay = item.tsDays.find((item) => moment(item.date).format('DD/MM/YYYY') === key);
					return tsDay;
				}
				return null;
			}
		},
		generateSecureIdDefault(item, key) {
			const text = `${item.id + item.fullName + item.departmentName + item.functionName + key}`;
			return generateSecureId(text);
		},
		generateCellsItem(cell) {
			const { securedId, item, key, tsDay, isNoActiveChift } = cell;
			const indexOfItem = [...this.mapTimesheets].findIndex(
				(userData) =>
					+userData.id === +item.id &&
					userData.fullName === item.fullName &&
					userData.functionName === item.functionName &&
					userData.departmentName === item.departmentName &&
					userData.date === item.date
			);
			return {
				securedId: securedId,
				userId: +item.id,
				fullName: item.fullName,
				functionName: item.functionName,
				managerSalaryAcess: item.managerSalaryAcess,
				date: key,
				indexOfItem: indexOfItem,
				dataAdd: item,
				tsDay: tsDay,
				isNoActiveChift: isNoActiveChift
			};
		},
		handleCtrlClick(event, item, key) {
			const TYPE = this.TYPE_SELECT_PLANNING.CTRL;
			const securedId = this.generateSecureIdDefault(item, key);
			const tsDay = this.getTsDayOneCell(item, key);
			const isNoActiveChift = true;
			const cell = { securedId, item, key, tsDay, isNoActiveChift };
			this.setDefaultSelectForPlanning(cell, TYPE);
			return true;
		},
		setDefaultSelectForPlanning(cell, type) {
			const TYPE = type;
			const rowItem = this.generateCellsItem(cell);
			const { arrayActive, arrayDisabled } = this.arrayDiffPlanning(rowItem, TYPE);
			this.dataForPlanning = this.getUniqueCombination(arrayActive);
			this.inactiveCellsPlanningColor(arrayDisabled);
			this.activeCellsPlanningColor(arrayActive);
		},
		handleClickOnly(event, item, key) {
			const TYPE = this.TYPE_SELECT_PLANNING.CLICK;
			const securedId = this.generateSecureIdDefault(item, key);
			const tsDay = this.getTsDayOneCell(item, key);
			const isNoActiveChift = true;
			const cell = { securedId, item, key, tsDay, isNoActiveChift };
			this.setDefaultSelectForPlanning(cell, TYPE);
			return true;
		},
		handleShiftWithClick(event, item, key) {
			const TYPE = this.TYPE_SELECT_PLANNING.SHIFT;
			const securedId = this.generateSecureIdDefault(item, key);
			const tsDay = this.getTsDayOneCell(item, key);
			let isNoActiveChift = false;
			if (this.mapSelectedCells.length === 0) {
				isNoActiveChift = true;
			}
			const cell = { securedId, item, key, tsDay, isNoActiveChift };
			this.setDefaultSelectForPlanning(cell, TYPE);
			return true;
		},
		handleAllActionPlanning(event, item, key) {
			if (this.showMenu) {
				this.showMenu = false;
				this.$refs['ContextMenu'].$refs['menu'].hide();
				this.$refs['ContextMenu'].optionContextMenu = null;
			}
			if (this.showMenuMultiple) {
				this.showMenuMultiple = false;
				this.$refs['ContextMenu'].$refs['menu'].hide();
				this.$refs['ContextMenu'].optionContextMenu = null;
			}
			if (event.ctrlKey || event.metaKey) {
				this.handleCtrlClick(event, item, key);
			} else if (event.shiftKey) {
				this.handleShiftWithClick(event, item, key);
			} else {
				this.handleClickOnly(event, item, key);
			}
		},
		handleSendDataPlanningToModal() {
			let data = [...this.dataForPlanning];
			this.$emit('setDataSizeModalPlanning', data);
		},
		setDateDefaultSelect(_date) {
			this.$emit('changeDateDefaultSelect', _date);
			this.dataForPlanning = [];
			this.selectedCells = [];
			this.indexActif = 0;
			this.handleSendDataPlanningToModal();
		},
		generateCellSelected(_item) {
			const arrays = [...this.dataForPlanning];
			let defaultSelected = [];
			let tsDay = null;
			let securedId = null;
			let locations = null;
			let key = null;
			let tsDays = [];
			let item = null;
			if (_item && _item.tsDay) {
				item = _item;
				let headerLocation = this.tsfields.find((_item) => _item.key === moment(item.tsDay.date).format('DD/MM/YYYY'));
				const { date } = item.tsDay;
				tsDay = item.tsDay;
				tsDays = item.tsDay;
				key = moment(date).format('DD/MM/YYYY'); // date format 01/01/2023;
				locations = headerLocation ? headerLocation.locations : null;
				securedId = this.generateSecureIdDefault(item, key);
				const isNoActiveChift = true;
				const cell = { securedId, item, locations, key, tsDay, isNoActiveChift };
				const data = [this.generateCellsItem(cell)];
				defaultSelected = data;
			}
			return { data: arrays.length > 0 ? arrays : defaultSelected, tsDay, tsDays, securedId, securedId, key, item };
		},
		isElseWhere(item, newItem) {
			const { data } = this.generateCellSelected(item);
			const { key } = newItem;
			const newSecuredId = this.generateSecureIdDefault(item, key);
			const inCase = data.map(({ securedId }) => securedId).includes(newSecuredId);
			return {
				inCase
			};
		},
		async onActiveContextMenu(event, data, item) {
			this.hideContextMenu();
			const { inCase } = this.isElseWhere(item, data);
			const excuteAction = async () => {
				const numberSelectedPlanning = [...this.dataForPlanning].length; // unique data for planning selection even cell empty (don't clear)
				const isCheckCell = this.getWorked(data.key, item.tsDays);
				const isActive = isCheckCell && this.isSelectMultiple === false;
				const type = isActive
					? this.TYPE_CONTEXT_MENU.ONE_SELECT
					: numberSelectedPlanning > 1
					? this.TYPE_CONTEXT_MENU.MULTI_SELECT
					: this.TYPE_CONTEXT_MENU.ONE_SELECT;
				const worked = this.getDataOnCell(data.key, item);
				const result = await this.showContextMenu(type, event, worked);
				return result;
			};
			if (inCase) {
				excuteAction();
			} else {
				const { key } = data;
				const response = this.handleClickOnly(event, item, key, data);
				return await new Promise((resolve, _) => resolve(response)).then((res) => {
					if (res) {
						excuteAction();
					}
				});
			}
		},
		isAuthorizedShowContext(item) {
			let isBoolean = false;
			const { data: rowItem } = this.generateCellSelected(item);
			const tsDays = rowItem
				.map((item) => {
					const arrays = Object.keys(item);
					const index = arrays.findIndex((item) => item === 'tsDay');
					if (index !== -1) {
						if (!_.isNil(item.tsDay)) {
							const { tsDay } = item;
							const unique = [...Object.keys(tsDay)];
							if (unique.length > 1) {
								return tsDay;
							} else {
								return null;
							}
						}
						return null;
					} else {
						return null;
					}
				})
				.filter((isTsDay) => isTsDay);
			if (tsDays.length !== 0) {
				isBoolean = true;
			}
			return {
				authorizedShow: isBoolean
			};
		},
		async showContextMenu(type, event, worked) {
			this.showMenu = false;
			this.showMenuMultiple = false;
			const { authorizedShow } = this.isAuthorizedShowContext(worked);
			if (authorizedShow) {
				const isContextMenu = this.$refs['ContextMenu'];
				isContextMenu.$refs['menu'].hide();
				isContextMenu.optionContextMenu = null;
				const response = await Promise.all([isContextMenu.optionContextMenu]).then((res) => {
					if (res) {
						const showMenu = type === this.TYPE_CONTEXT_MENU.ONE_SELECT ? 'showMenu' : 'showMenuMultiple';
						this[showMenu] = true;
						const optionContextMenu = (isContextMenu.optionContextMenu = this.setOptionContextMenu(worked, event));
						if (!_.isNil(optionContextMenu)) {
							isContextMenu.$refs['menu'].show(event);
						}
						return true;
					}
					return false;
				});
				return response;
			}
		},
		hideContextMenuStopPropagation() {
			const contextMenu = this.$refs['ContextMenu'];
			if (contextMenu) {
				this.$refs['ContextMenu'].$refs['menu'].hide();
				this.$refs['ContextMenu'].optionContextMenu = null;
			}
		},
		hideContextMenuScrolled() {
			if (this.showMenu) {
				this.showMenu = false;
				this.showMenuMultiple = false;
				this.selectedItem = null;
				this.dataForPlanning = [];
				this.$refs['ContextMenu'].$refs['menu'].hide();
				this.$refs['ContextMenu'].optionContextMenu = null;
			} else {
				if (this.dataForPlanning.length !== 0) {
					this.showMenu = false;
					this.showMenuMultiple = false;
					this.selectedItem = null;
					this.$refs['ContextMenu'].$refs['menu'].hide();
					this.$refs['ContextMenu'].optionContextMenu = null;
				}
			}
		},
		setOptionContextMenu(worked, event) {
			this.selectedItem = worked;
			const table = this.$refs['my-table'].$el;
			const tableRect = table.getBoundingClientRect();
			const { data: rowItem } = this.generateCellSelected(this.selectedItem);
			if (this.dataForPlanning.length === 0 && this.selectedItem) {
				const { arrayActive, arrayDisabled } = this.arrayDiffPlanning(rowItem[0], this.TYPE_SELECT_PLANNING.CLICK);
				this.dataForPlanning = this.getUniqueCombination(arrayActive);
				this.inactiveCellsPlanningColor(arrayDisabled);
				this.activeCellsPlanningColor(arrayActive);
				this.mapSelectedCells = arrayActive;
			}
			return {
				showMenu: this.showMenu,
				showMenuMultiple: this.showMenuMultiple,
				isShowActionByStatus: this.isShowActionByStatus(rowItem),
				isNotValitedItem: this.isNotValitedItem(rowItem),
				isValidated: this.isValidated(rowItem),
				isUndoReject: this.isUndoReject(rowItem),
				onMenuItemClick: (type) => this.onMenuItemClick(type),
				hideContextMenuStopPropagation: () => this.hideContextMenuStopPropagation(),
				isValid: this.isValid,
				isReject: this.isReject,
				tableRect,
				event,
				rowItem
			};
		},
		initActionsInPlanning() {
			this.inactiveCellsPlanningColor(this.dataForPlanning);
			this.showMenu = false;
			this.showMenuMultiple = false;
			this.selectedItem = null;
			this.dataForPlanning = [];
			this.hideContextMenuStopPropagation();
			this.GetTimesheetsToValidate();
		},
		hideContextMenu() {
			this.showMenu = false;
			this.showMenuMultiple = false;
			this.selectedItem = null;
			this.hideContextMenuStopPropagation();
		},
		isNotValitedItem(item) {
			const { NOT_SUBMITTED } = VALIDATION_TYPE;
			const response = [...this.filterTypeDataAuth(item)].map(({ tsDay }) => tsDay).filter(({ validated }) => validated === NOT_SUBMITTED);
			if (response.length !== 0) {
				return true;
			}
			return false;
		},
		filterTypeDataAuth(data) {
			return data.filter(({ tsDay }) => tsDay !== undefined);
		},
		isShowActionByStatus(item) {
			const { SUBMITTED, VALIDATED_LEVEL_1, VALIDATED_LEVEL_2 } = VALIDATION_TYPE;
			const response = [...this.filterTypeDataAuth(item)]
				.map(({ tsDay }) => tsDay)
				.some(({ validated }) => (validated === SUBMITTED || validated === VALIDATED_LEVEL_1 || validated === VALIDATED_LEVEL_2 ? false : true));
			return response;
		},
		isValidated(item) {
			const { SUBMITTED, VALIDATED_LEVEL_1 } = VALIDATION_TYPE;
			const { tsDay } = item[0];
			if (tsDay) {
				const { validated } = tsDay;
				if (validated === VALIDATED_LEVEL_1) {
					this.isReject = true;
					this.isValid = false;
					return true;
				}
				if (validated === SUBMITTED) {
					this.isReject = false;
					this.isValid = true;
					return true;
				} else {
					this.isValid = false;
					this.isReject = false;
					return false;
				}
			} else {
				this.isValid = false;
				this.isReject = false;
				return false;
			}
		},
		isUndoReject(item) {
			const { REFUSED_LEVEL_1 } = VALIDATION_TYPE;
			const { data: rowItem } = this.generateCellSelected(item);
			const newItem = this.filterTypeDataAuth(rowItem);
			if (newItem && newItem.length !== 0) {
				const tsDays = newItem.map(({ tsDay }) => tsDay);
				const validateds = tsDays.filter(({ validated }) => validated === REFUSED_LEVEL_1);
				if (validateds.length !== 0) {
					return true;
				}
				return false;
			}
		},
		async onMenuItemClick(option) {
			const { SEND_FOR_VALIDATION, UPDATE, UNDO_REJECT, SEE_INFO, DELETE, VALIDATE, REJECT, SEE_INFO_MULTIPLE } = OPTION_CONTEXT_MENU;
			const { SUBMITTED, REFUSED_LEVEL_1, REFUSED_LEVEL_2, VALIDATED_LEVEL_1, VALIDATED_LEVEL_2 } = VALIDATION_TYPE;
			if (option === UPDATE) {
				const { data: rowItem } = this.generateCellSelected(this.selectedItem);
				const _item = this.filterTypeDataAuth(rowItem);
				return this.$emit('showModalPlanningContextUpdate', _item);
			}
			if (option === SEND_FOR_VALIDATION) {
				const { data: rowItem } = this.generateCellSelected(this.selectedItem);
				const tsDays = this.filterTypeDataAuth(rowItem).map(({ tsDay }) => tsDay);
				return this.$emit('sendForValidationPlanning', tsDays);
			}
			if (option === VALIDATE) {
				const { data: rowItem } = this.generateCellSelected(this.selectedItem);
				const tsDays = this.filterTypeDataAuth(rowItem)
					.map(({ tsDay }) => tsDay)
					.filter(({ validated }) => validated !== VALIDATED_LEVEL_2);
				return this.$emit('validateTsDays', tsDays);
			}
			if (option === REJECT) {
				const { data: rowItem } = this.generateCellSelected(this.selectedItem);
				const tsDays = this.filterTypeDataAuth(rowItem).map(({ tsDay }) => tsDay);
				this.successModalRejectedTsDay = true;
				this.rejectData = tsDays;
				return this.rejectData;
			}
			if (option === UNDO_REJECT) {
				const { data: rowItem } = this.generateCellSelected(this.selectedItem);
				const tsDays = this.filterTypeDataAuth(rowItem)
					.map(({ tsDay }) => tsDay)
					.filter(({ validated }) => validated === REFUSED_LEVEL_1 || validated === REFUSED_LEVEL_2);
				const response = tsDays.map(async ({ id }) => {
					const newID = +id;
					const exc = await undoRejectTsDay(newID);
					return exc;
				});
				if (response !== null) {
					return this.$emit('handleRefreshReject');
				}
				return response;
			}
			if (option === SEE_INFO) {
				const { data: rowItem } = this.generateCellSelected(this.selectedItem);
				const newItem = this.filterTypeDataAuth(rowItem);
				this.detailGenerateItem = newItem;
				return new Promise((resolve, _) => resolve(this.detailGenerateItem)).then((res) => {
					if (res) {
						this.isMultiple = false;
						this.showDetailModalCell = true;
						return this.showDetailModalCell;
					}
				});
			}
			if (option === SEE_INFO_MULTIPLE) {
				const { data: rowItem } = this.generateCellSelected(this.selectedItem);
				const newItem = this.filterTypeDataAuth(rowItem);
				this.detailGenerateItem = newItem;
				return new Promise((resolve, _) => resolve(this.detailGenerateItem)).then((res) => {
					if (res) {
						this.isMultiple = true;
						this.showDetailModalCell = true;
						return this.showDetailModalCell;
					}
				});
			}
			if (option === DELETE) {
				const { data: rowItem } = this.generateCellSelected(this.selectedItem);
				const tsDays = this.filterTypeDataAuth(rowItem)
					.map(({ tsDay }) => tsDay)
					.filter(({ validated }) => validated !== SUBMITTED && validated !== VALIDATED_LEVEL_1 && validated !== VALIDATED_LEVEL_2);
				return this.$emit('deleteItemPlanning', tsDays);
			}
		},
		hideModal() {
			this.showDetailModalCell = false;
			return new Promise((resolve, _) => resolve(this.showDetailModal)).then((res) => {
				if (res) {
					this.detailGenerateItem = [];
				}
			});
		},
		sendAllForValidation(item) {
			let data = item.tsDays.filter((item) => item.validated === 0);
			return this.$emit('sendForValidationPlanning', data);
		},
		checkNotSubmitted(item) {
			let data = item.tsDays.filter((item) => item.validated === 0);
			if (data.length === 0) {
				return true;
			} else {
				return false;
			}
		},
		onScroll(event) {
			if (this.mapTimesheets.length < this.totalsPlanningTsDays && event.target.scrollTop) {
				if (Math.ceil(event.target.scrollTop + event.target.clientHeight + 1) >= event.target.scrollHeight) {
					if (!this.isBusy) {
						if (event.target.scrollLeft) {
							this.isBusy = false;
						}
						const recordOffSet = 1;
						this.$emit('getDataFromPagePlanning', recordOffSet);
					}
				}
			}
		},
		startScrollingLeft(event) {
			event.preventDefault();
			const scrollContainer = this.$refs['my-table'].$el;
			this.isDragging = true;
			this.startX = event.clientX;
			this.scrollLeftStart = scrollContainer.scrollLeft;
		},
		stopScrollingLeft(event) {
			event.preventDefault();
			const scrollContainer = this.$refs['my-table'].$el;
			scrollContainer.removeEventListener('mousedown', this.startScrollingLeft);
		},
		detectDirection(event) {
			event.preventDefault();
			if (this.isDragging) {
				const mouseX = event.clientX;
				const scrollContainer = this.$refs['my-table'].$el;
				if (mouseX > this.startX) {
					scrollContainer.scrollLeft = this.scrollLeftStart + (mouseX - this.startX);
				} else if (mouseX < this.startX) {
					scrollContainer.scrollLeft = this.scrollLeftStart - (this.startX - mouseX);
				}
			}
		},
		stopDrag() {
			this.isDragging = false;
		}
	}
};
</script>
<style scoped>
.middle {
	vertical-align: middle;
}
.show-hover:hover {
	background-color: #cad0d7;
	border-radius: 5px;
	cursor: pointer;
}
.edit-background {
	/* vertical-align: middle; */
	background-color: #f3f4f5;
}
.init-background {
	/*vertical-align: middle;*/
	background-color: #ffff;
}
.sticky-column-body {
	position: sticky;
	left: 0;
	z-index: 1;
	background-color: #fff;
}
.hover-not-empty:hover {
	background-color: hsla(206, 96%, 90%, 0.5);
}
.hover-is-empty:hover {
	background-color: rgba(71, 199, 191, 0.5);
}
.context-menu {
	position: fixed;
	z-index: 2;
	background-color: #fff;
	border: 1px solid #ccc;
	padding: 8px;
	border-radius: 10px;
}
.context-menu div {
	cursor: pointer;
	padding: 8px;
}
.menu-context {
	height: 30px;
}
.menu-context:hover {
	background-color: rgba(71, 199, 191, 0.5);
	border-radius: 10px;
}

@keyframes c4 {
	to {
		clip-path: inset(0 -1ch 0 0);
	}
}
.loading,
.end-of-list {
	color: rgba(6, 38, 62, 0.84);
	font-weight: 900;
	font-size: 0.95rem;
}
.bars-5 {
	width: 20px;
	height: 10px;
	aspect-ratio: 0.75;
	--c: no-repeat linear-gradient(rgba(6, 38, 62, 0.84) 0 0);
	background: var(--c) 0% 100%, var(--c) 50% 100%, var(--c) 100% 100%;
	background-size: 20% 65%;
	animation: b5 1s infinite linear;
}
@keyframes b5 {
	20% {
		background-position: 0% 50%, 50% 100%, 100% 100%;
	}
	40% {
		background-position: 0% 0%, 50% 50%, 100% 100%;
	}
	60% {
		background-position: 0% 100%, 50% 0%, 100% 50%;
	}
	80% {
		background-position: 0% 100%, 50% 100%, 100% 0%;
	}
}
.overflow-hidden {
	overflow: hidden;
}
::-webkit-scrollbar {
	width: 5px;
	background: #eee;
}
::-webkit-scrollbar:horizontal {
	height: 10px;
}
::-webkit-scrollbar-button {
	width: 5px;
	height: 5px;
	background: #666;
}
::-webkit-scrollbar-piece {
	background: #eee;
}
::-webkit-scrollbar-piece:start {
	background: #eee;
}
::-webkit-scrollbar-thumb {
	background: #333;
}
::-webkit-scrollbar-corner {
	background: #333;
}
@keyframes sonar {
	0% {
		transform: scale(0.6);
		opacity: 1;
	}
	100% {
		transform: scale(1.2);
		opacity: 0;
	}
}
@keyframes pulse {
	0% {
		transform: scale(1);
	}
	20% {
		transform: scale(0.9);
	}
	50% {
		transform: scale(1);
	}
	80% {
		transform: scale(0.6);
	}
	100% {
		transform: scale(1);
	}
}
.row-header-fixed {
	position: sticky !important;
	left: 0 !important;
	z-index: 10 !important;
	background-color: #00a09c !important;
	border: 1px solid #dee2e6 !important;
	color: #ffff !important;
	top: -1px !important;
}
.row-header-locations {
	background-color: #00a09c !important;
	border: 1px solid #dee2e6 !important;
	color: #ffff !important;
	top: -1px !important;
}
.default-data-empty {
	border: 0.005rem solid rgba(226, 230, 235, 0.85) !important;
	height: 50px !important;
}
.bg-header-today {
	background-color: #036d6b !important;
}
.bg-row-today {
	background-color: hsla(206, 96%, 90%, 0.5);
}
</style>
<style lang="scss">
.fixed-app-bar {
	position: fixed !important;
	animation-duration: 0.5s;
	animation-name: showTransitionBar;
}
.popover:has(.row-today-popover) {
	background-color: #000 !important;
	top: -120px !important;
	.arrow::before {
		display: none;
	}
	.arrow::after {
		border-bottom-color: #000 !important;
		top: 42px !important;
		transform: rotate(180deg) !important;
	}
	.popover-body {
		.row-today-popover {
			color: #fff !important;
			font-weight: 700;
		}
	}
}
.resizable {
	cursor: w-resize;
	user-select: none;
}
.cursor-wait {
	cursor: wait !important;
}
.margin-before-last-header-active {
	margin-right: 50px;
}
.margin-last-header-active {
	left: -50px;
}
</style>
